import { render } from "./maps.vue?vue&type=template&id=0bf8a6d9"
import script from "./maps.vue?vue&type=script&lang=js"
export * from "./maps.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__